import triToggleDirective from "./tri-toggle-directive";

export {triToggleDirective};
